import { createCrudSlice } from "./createCrudSlice";
import { GET_AUDIT_LOG_DETAILS, GET_AUDIT_LOGS } from "helpers/url_helper";

const { reducer, actions, thunks } = createCrudSlice({
  name: "loggers",

  initialFilters: {
    keyword: "",
    status: -1,
    orderBy: -1,
    dates: [],
    pageNo: 1,
    perPage: 50,
  },
  urls:{},

  additionalThunks: {
    getAuditLogs: {
      type: "loggers/getAuditLog",
      url: () => `${GET_AUDIT_LOGS}`,
      method: "post",
      stateKey: "auditLogs",
      loadingKey: "loading",
    },
    getAuditLogDetails: {
      type: "loggers/getAuditLogDetails",
      url: (id) => `${GET_AUDIT_LOG_DETAILS}/${id}`,
      method: "get",
      stateKey: "auditLogDetails",
      loadingKey: "loading",
    },
  },

  initialState: {
    loading: true,
    submitRefundForm: false,
    auditLogs: [],
    auditLogDetails: [],
    actionType:"",
    performedByRole:"",
    auditLogModule:""
  },
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } = actions;

// Export thunks
export const { getAuditLogs ,getAuditLogDetails } = thunks;

// Export reducer
export default reducer;
